<template>
  <p :dir="direction">
    {{ text }}
  </p>
</template>

<script>
export default {
  name: "WDText",
  props: ["text"],
  data() {
    return {
      en: /[a-zA-Z0-9]/,
      ar: /[\u0621-\u064A]/,
      direction: "ltr",
    };
  },
  mounted() {
    if (this.ar.test(this.text[0])) {
      this.direction = "rtl";
    } else {
      this.direction = "ltr";
    }
  },
};
</script>

<style lang="scss" scoped>
p {
  white-space: pre-line;
}
</style>
